__turbopack_context__.v({
  "content": "BreadCrumbs-module-scss-module__Roc20q__content",
  "dot": "BreadCrumbs-module-scss-module__Roc20q__dot",
  "dotWrapper": "BreadCrumbs-module-scss-module__Roc20q__dotWrapper",
  "item": "BreadCrumbs-module-scss-module__Roc20q__item",
  "link": "BreadCrumbs-module-scss-module__Roc20q__link",
  "listItem": "BreadCrumbs-module-scss-module__Roc20q__listItem",
  "textComponent": "BreadCrumbs-module-scss-module__Roc20q__textComponent",
});
